import { useAtomValue } from "jotai";
import { SelectPicker } from "rsuite";
import { modulesAtom } from "../../atoms/GlobalAtoms";
import { Button } from "reactstrap";

interface Props {
  moduleAPIName?: string;
  handleSelectModule: (value: string) => void;
  changeStep: (step: string) => void;
}

const FormBuilderModuleSelection = ({
  moduleAPIName,
  handleSelectModule,
  changeStep,
}: Props) => {
  const modules = useAtomValue(modulesAtom);
  const moduleOptions = !!modules?.length
    ? modules?.filter(
        (module) =>
          !module.Default ||
          ["Contacts", "Companies", "Activities"].includes(module?.APIName)
      )
    : [];

  const handleNext = () => {
    if (!moduleAPIName) return;
    changeStep("select-fields");
  };

  return (
    <div className="d-flex align-items-center justify-content-center h-100">
      <div
        style={{
          boxShadow: "0px 1px 8px 2px rgba(0, 0, 0, 0.15)",
          maxWidth: 400,
        }}
      >
        <div className="d-flex flex-column p-4 h-100">
          <h3 className="mb-1">Form Data Source</h3>
          <p className="text-sm">
            Select the data source you want to build the form with.
          </p>
          <SelectPicker
            className="mt-2 mb-2"
            data={moduleOptions}
            placeholder="Select Data Source"
            cleanable
            onChange={(value: any) => handleSelectModule(value)}
            value={moduleAPIName}
            labelKey="Name"
            valueKey="APIName"
            preventOverflow
          />
          <Button
            color="primary"
            className="align-self-center mt-4"
            onClick={() => handleNext()}
            disabled={!moduleAPIName}
            block
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FormBuilderModuleSelection;
